export default class Facebook {
    constructor(Rest) {
        this.rest = Rest.rest;
    }

    getPages() {
        return this.rest.one('facebook/pages').get();
    };

    storePage(page) {
        return this.rest.all('facebook/pages').post(page);
    };

    deletePage(pageId) {
        return this.rest.one('facebook').one('pages/' + pageId).remove();
    };

    getPageSubscribers(pageId, accessToken) {
        return this.rest.all('facebook/pages/' + pageId + '/subscribers').get();
    };

    getFacebookPages(accessToken) {
        return this.rest.one('facebook/facebook_pages/' + accessToken).get();
    };

    uploadSubscribers(customer_id, customer_name, segmentId) {
        return this.rest.one(`facebook/segment/${segmentId}/customer`).put({
            customer_id,
            customer_name
        });
    }

    uploadGoogleSubscribers(googleAccountId, googleCustomerId, segmentId) {
        return this.rest.all(`google/accounts/${ googleAccountId }/customers/${ googleCustomerId }/upload-subscribers`).post({
            filter_id: segmentId
        });
    }

    getGoogleAuthUrl(returnUrl) {
        return this.rest.one(`google/auth-url`).get({
            return_url: returnUrl
        });
    }

    getGoogleLoginCallback() {
        return this.rest.one('google/loginCallback').get();
    }

    checkGoogleAccount() {
        return this.rest.one('google/account').get();
    }

    getGoogleAdAccounts(googleAccountId) {
        return this.rest.one('google/accounts/' + googleAccountId + '/customers').get();
    }

    disconnectGoogleAdAccount(segmentId) {
        return this.rest.one('google/audience/remove-connection').remove({ filter_id: segmentId });
    }

    getFacebookAuthUrl(segmentId, returnUrl) {
        return this.rest.one(`facebook/segment/${segmentId}/audience/redirect-url`).get({
            return_url: returnUrl
        });
    }

    getAdAccounts(segmentId) {
        return this.rest.one(`facebook/segment/${segmentId}/ad-accounts`).get();
    }
};
